<template>
  <svg :class="[$style['svg-icon'], { [$style[`svg-icon--${size}`]]: size }]">
    <use :href="`#${name}`" />{{ size }}
  </svg>
</template>

<script setup>
defineProps({
  name: {
    type: String,
    default: null
  },
  size: {
    type: String,
    default: null
  }
})
</script>
<style lang="scss" module>
.svg-icon {
  align-items: center;
  justify-content: center;
  display: inline-flex;
  line-height: 1;
  width: calc(var(--spacing) * 3);
  height: calc(var(--spacing) * 3);

  &--small {
    width: calc(var(--spacing) * 2);
    height: calc(var(--spacing) * 2);
  }

  &--medium {
    width: calc(var(--spacing) * 2.5);
    height: calc(var(--spacing) * 2.5);
  }

  &--large {
    width: calc(var(--spacing) * 3.5);
    height: calc(var(--spacing) * 3.5);
  }
}
</style>
